import React from "react";
import { Result } from "antd";

function NotFound() {
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
      }}
    >
      <Result status="404" title="404" subTitle="页面不见了......" />
    </div>
  );
}

export default NotFound;
